import React from 'react';
import c from 'classnames';
import s from './Star.scss';

interface Props {
  className?: string;
  fill: 'themed' | 'white';
}

const Star: React.FC<Props> = ({ fill, className }) => {
  return (
    <svg
      className={c(
        s['root'],
        fill === 'themed' && s['themed'],
        fill === 'white' && s['white'],
        className
      )}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.80612 0.00195312L8.64439 4.9698L13.6122 6.80807L8.64439 8.64634L6.80612 13.6142L4.96785 8.64634L0 6.80807L4.96785 4.9698L6.80612 0.00195312Z"
        fill="white"
      />
    </svg>
  );
};

Star.displayName = 'Star';

export default Star;
